var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 195,
    viewBox: "0 0 241 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.174 39.2802C117.174 40.2049 116.828 42.0277 115.443 41.9212",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.699 36.0625L125.829 37.8601C126.495 38.4218 127.027 39.2802 127.027 40.3234C127.027 40.8957 126.763 41.285 126.393 41.5311C125.388 42.2002 124.515 41.317 124.053 40.2012V40.2012C123.456 38.7589 121.453 38.8315 119.975 39.3338C119.139 39.6182 118.172 39.6854 117.174 39.2802C116.689 39.0833 116.197 38.7751 115.709 38.3261",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.495 34.84C127.226 35.3375 128.242 35.9083 128.816 36.6713C128.97 36.876 129.029 36.9435 129.073 37.1959V37.1959C129.362 38.8545 127.149 38.9736 125.862 37.8879L125.829 37.8601L123.699 36.0625",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.5 30.7364C123.992 30.5234 127.028 31.1803 128.359 31.5353C130.623 32.2011 131.715 34.3049 130.223 35.2636C129.294 35.8608 127.801 35.4557 126.495 34.84C125.705 34.4672 124.983 34.0173 124.498 33.6658",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.253 37.7935C108.83 33.9321 111.901 26.3957 119.571 27.1413C122.725 27.4479 124.891 27.8551 126.345 28.2684C128.183 28.7907 130.266 31.4232 128.359 31.5354V31.5354",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.51 23.3544C165.573 24.8029 162.261 34.525 167.438 37.1121C173.616 40.2001 175.744 22.8135 174.94 15.4337C174.709 12.198 170.941 10.7587 170.433 15.4337C169.893 20.3997 176.056 39.6561 183.119 32.2256L187.834 26.7701C189.145 25.1558 191.728 22.913 193.911 26.7701C196.094 30.6271 199.572 29.3525 201.038 28.233L205.646 24.8819",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M200.229 10.4467L238.655 3.78601C239.638 3.6157 240.237 4.83091 239.504 5.50669L222.318 21.3442C222.244 21.4122 222.162 21.471 222.067 21.5007C220.396 22.0178 214.839 19.8482 211.412 18.3199C210.844 18.0669 210.182 18.3759 210.008 18.9723C209.359 21.1988 208.638 23.2262 208.17 24.4499C208.001 24.8927 207.542 25.055 207.356 24.619C206.714 23.1141 206.591 19.0751 206.626 16.3597C206.633 15.8474 206.257 15.4112 205.764 15.2741C203.347 14.6027 200.334 12.5912 199 11.5607",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M210 18.2062C214.249 16.2145 224.997 11.226 234 7.20624",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M208 25.2062L216 20.2062",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M209 14.2062L220 10.2062",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.32294 190.099C-1.91317 188.15 8.02226 188.294 12.926 188.204C13.6322 189.179 14.152 189.197 15.427 189.422C16.0154 190.911 2.55905 192.047 0.32294 190.099Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2595 43.3344C74.7232 44.9131 74.3235 50.0433 76.4294 54.2529",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0327 55.576C78.1622 54.0836 86.0259 52.2573 86.0259 57.4199V58.3158C86.0259 58.9207 86.711 59.2634 87.1849 58.8929C93.8142 53.7128 103.06 45.3316 107.454 38.9403C107.765 38.4965 108.786 37.8218 110.383 38.674C112.381 39.7392 115.044 40.2718 115.31 43.8669C115.576 47.4621 112.381 56.9159 103.459 67.0355C96.3224 75.1311 95.9021 76.7556 94.6713 80.3507C92.9847 85.2774 89.4518 98.2464 88.8126 110.709",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3571 15.6386C96.3682 18.8384 102.594 25.745 96.5427 28.5547C96.1879 28.7193 95.9921 29.1177 96.0932 29.4976C97.2838 33.9646 97.0955 43.1888 87.8597 49.4353C87.7223 49.5281 87.6165 49.6662 87.5664 49.825L85.75 55.5843",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1737 39.0735C88.0283 39.7925 88.4058 41.2785 91.0763 41.4702",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3373 22.6958C95.3373 24.0573 94.9138 25.2547 94.2736 26.091C93.6333 26.927 92.8226 27.3561 92.0085 27.3561C91.1944 27.3561 90.3837 26.927 89.7434 26.091C89.1032 25.2547 88.6797 24.0573 88.6797 22.6958C88.6797 21.3343 89.1032 20.1369 89.7434 19.3006C90.3837 18.4646 91.1944 18.0355 92.0085 18.0355C92.8226 18.0355 93.6333 18.4646 94.2736 19.3006C94.9138 20.1369 95.3373 21.3343 95.3373 22.6958Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1577 26.8234L88.1469 24.1604",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5493 21.2311C86.7595 20.4028 87.5334 18.497 88.9461 17.5029",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6741 23.6277C93.2624 23.6277 93.7393 23.2104 93.7393 22.6957C93.7393 22.1809 93.2624 21.7636 92.6741 21.7636C92.0858 21.7636 91.6089 22.1809 91.6089 22.6957C91.6089 23.2104 92.0858 23.6277 92.6741 23.6277Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0327 55.318L43.1414 91.0028",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1414 91.1148C45.4119 90.8039 51.3142 90.9547 56.7628 94.0472C63.5737 97.9128 70.7848 104.711 88.6795 110.709",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6795 110.709L82.8208 114.704",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1694 91.0029C42.7168 92.3746 42.2675 95.5739 46.0707 99.5247",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5109 65.1713C60.635 69.2655 48.2711 77.9031 37.8225 79.6995C35.3847 80.7119 31.188 83.5558 33.9045 86.8311C36.6211 90.1068 38.4323 94.0954 38.9983 95.6801C39.4337 97.1331 40.5173 99.1588 43.1295 94.5098",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6196 88.0737C32.5622 89.2869 27.7644 91.6052 25.0329 91.1737C22.3013 90.7425 20.4802 91.8927 19.9111 92.5217C19.6047 93.0159 19.4121 94.0313 21.0931 94.1392C22.774 94.247 24.7702 94.184 25.5581 94.1392",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.962 92.3344C27.0174 93.3669 23.8061 95.7135 18.5167 96.84C17.4823 97.0277 16.088 98.107 17.9771 99.3744C19.5962 100.36 24.0759 99.4589 26.3428 98.107",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2521 97.9269C24.6079 98.779 21.6484 101.047 22.9638 103.307C23.3853 103.755 25.1644 103.791 28.908 100.348L31.6904 97.9269",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0998 97.9781L29.1754 100.421C28.3335 102.638 27.0486 108.021 30.5047 105.035C33.0303 102.457 32.4986 100.258 33.562 99.6066C34.6254 98.9553 37.0181 96.4402 38.0816 95.2638",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9592 93.666C31.6049 94.8776 31.3215 97.6926 33.022 99.2584",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1792 183.144C65.8314 182.704 69.1619 180.474 69.2661 175.08C69.3706 169.686 71.5706 160.405 72.6573 156.439L83.3532 108.845",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M87.481 31.6169C87.7016 31.6169 87.8805 31.4381 87.8805 31.2175C87.8805 30.9968 87.7016 30.818 87.481 30.818C87.2604 30.818 87.0815 30.9968 87.0815 31.2175C87.0815 31.4381 87.2604 31.6169 87.481 31.6169Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2121 33.4811C89.3592 33.4811 89.4784 33.3023 89.4784 33.0816C89.4784 32.861 89.3592 32.6822 89.2121 32.6822C89.065 32.6822 88.9458 32.861 88.9458 33.0816C88.9458 33.3023 89.065 33.4811 89.2121 33.4811Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3506 34.28C85.5712 34.28 85.7501 34.1012 85.7501 33.8805C85.7501 33.6599 85.5712 33.4811 85.3506 33.4811C85.13 33.4811 84.9512 33.6599 84.9512 33.8805C84.9512 34.1012 85.13 34.28 85.3506 34.28Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3769 27.9317C52.7828 15.9619 62.3478 14.457 66.3298 15.2005C74.5995 2.46942 86.02 -1.73048 92.9772 2.07579C98.5431 5.12066 93.9837 12.7944 91.0082 16.2507L88.1205 12.0508C86.1251 15.9357 80.4194 14.5007 77.6188 13.6257C80.0253 18.7006 83.8671 31.817 75.7809 43.6818C67.6951 55.5467 57.5348 55.7564 52.415 52.3441C47.6895 48.9756 39.9711 39.9018 46.3769 27.9317Z",
    fill: "#E75B10"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6089 67.0355C93.1937 68.5678 96.0671 72.764 95.4703 77.8209",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6089 184.742C43.5468 186.124 46.6707 188.732 51.6633 188.11",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5424 92.0681C48.8761 96.8181 41.0695 106.582 34.0963 118.853C29.4476 126.55 18.3606 143.739 11.2033 150.917C10.2384 152.28 9.33495 155.376 13.4399 156.854C16.5976 158.173 18.0185 161.235 18.4396 164.507C18.9658 168.597 25.6759 171.632 30.1492 168.597C33.7147 166.178 43.9671 148.755 51.7125 138.909C53.6846 136.402 55.4941 134.387 56.9893 133.236",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3714 138.672L42.6089 184.742C47.0627 183.554 59.2974 181.31 66.8426 181.31",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22508 180.74C1.11462 166.776 7.70596 157.484 11.2708 155.182C16.797 156.944 16.9463 162.813 17.8424 165.602L15.7742 171.339C14.3902 173.807 15.1975 178.635 15.7742 180.74C18.1647 190.493 14.5567 191.43 12.786 188.818L8.22508 180.74Z",
    fill: "#3B82F6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7337 193.837C44.2585 191.901 49.154 191.15 54.1215 190.867C55.8521 192.396 67.3467 192.918 67.9076 193.271C62.6194 194.969 48.9029 195.534 46.7337 193.837Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8164 193.008C52.4484 195.549 48.6363 188.217 49.0262 183.931C52.1851 182.599 60.8717 182.115 64.9666 181.813C63.7965 184.597 65.259 184.233 66.2827 184.99C67.5992 185.898 71.2551 187.007 73.3025 187.108C82.5159 187.562 75.3012 192.352 70.8164 193.008Z",
    fill: "#3B82F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessImage);
export default __webpack_public_path__ + "static/media/success-image.bc133a4b.svg";
export { ForwardRef as ReactComponent };